import { Injectable } from '@angular/core';
import { DataClientService } from './data-client.service';
import { SessionService } from './session.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Utm } from '../shared/enums';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountFormatService {

  private accountNamesSubject = new BehaviorSubject<string | null>(null);


  constructor(
    private sessionService: SessionService,
    private dataClientService: DataClientService,
    private location: Location
  ) {

  }

  public getProductName() {
    let productName = '';
    switch (this.sessionService.sessionAccountType) {
      case 'ahorro':
        productName = 'ahorro-clasico';
        break;
      case 'sueldo':
        if (environment.mode === 'WEB' || environment.mode === 'WEB-PF') {
          if (Object.keys(this.getUtmParams('cuenta_sueldo')).length > 0) {
            productName = 'ahorro-sueldo'
          } else {
            productName = 'ahorro-falabella';
          }
        } else {
          productName = 'ahorro-falabella';
        }
        break;
      case 'cts':
        productName = 'cts';
        break;
      case 'ahorrosueldo':
        productName = 'ahorro-sueldo';
        break;
      case 'ahorro-sueldo':
        productName = 'ahorro-sueldo';
        break;
      default:
        productName = 'ahorro-clasica';
        break;
    }
    return productName;
  }

  public getName() {
    let accountName = '';
    if (this.sessionService.intention === 'ahorro-sueldo') {
      accountName = 'AhorroSueldo';
      return accountName;
    }
    switch (this.sessionService.sessionAccountType) {
      case 'ahorro':
        accountName = 'Ahorro';
        break;
      case 'sueldo':
        accountName = 'Flex';
        break;
      case 'cts':
        accountName = 'CTS';
        break;
      default:
        accountName = 'Ahorro';
        break;
    }
    return accountName;
  }

  public getAccountNameFromAssets(): Observable<string> {
    return this.accountNamesSubject.asObservable().pipe(
      filter((accountNames) => !!accountNames),
      map((accountNames) => {
        const accountsNames = JSON.parse(accountNames);
        let selectedAccountName = '';
        switch (this.sessionService.sessionAccountType) {
          case 'ahorro':
            selectedAccountName = accountsNames.ahorro;
            break;
          case 'sueldo':
            selectedAccountName = accountsNames.cuentaBF;
            break;
          case 'cts':
            selectedAccountName = accountsNames.CTS;
            break;
          case 'ahorrosueldo':
            selectedAccountName = accountsNames.ahorroSueldo;
            break;
          case 'ahorro-sueldo':
            selectedAccountName = accountsNames.ahorroSueldo;
            break;
          default:
            selectedAccountName = accountsNames.ahorro;
            break;
        }
        return selectedAccountName;
      })
    );
  }

  setAccountNames(accountNames: string) {
    this.accountNamesSubject.next(accountNames);
    this.sessionService.accountNames = accountNames;
  }

  public getAccountsNames() {
    const accountsNames = JSON.parse(this.sessionService.accountNames);
    return accountsNames;
  }

  public getNameGA() {
    let accountName = '';
    switch (this.sessionService.sessionAccountType) {
      case 'ahorro':
        this.dataClientService.isIsJointAccount() ?
          accountName = 'ahorro-mancomunado' : accountName = 'ahorro';
        break;
      case 'sueldo':
        this.dataClientService.isIsJointAccount() ?
          accountName = 'ahorrobf-mancomunado' : accountName = 'ahorrobf';
        break;
      case 'cts':
        this.dataClientService.isIsJointAccount() ?
          accountName = 'cts-mancomunado' : accountName = 'cts';
        break;
      case 'ahorro-sueldo':
        accountName = 'ahorro-sueldo';
        break;
      default:
        accountName = 'ahorrobf';
        break;
    }
    return accountName;
  }

  public getDescription() {
    const regex = /^Cuenta\s*/i;
    let accountDescription = '';
    this.getAccountNameFromAssets().subscribe((accountTitle) => {
      accountDescription = accountTitle;
    });
    return accountDescription.replace(regex, '').trim();
  }

  public getDocumentNumber() {
    let documentNumber = '';
    switch (this.sessionService.sessionAccountType) {
      case 'ahorro':
        documentNumber = this.sessionService.isJointAccount ? '41' : '31';
        break;
      case 'sueldo':
        documentNumber = this.sessionService.isJointAccount ? '21' : '11';
        break;
      case 'cts':
        documentNumber = '61';
        break;
      case 'ahorro-sueldo':
        documentNumber = '11';
        break;
      default:
        documentNumber = '31';
        break;
    }
    return documentNumber;
  }

  getUtmParams(utm): Utm {
    const url = this.location.normalize(this.location.path());
    const tmp_utm: Utm = {};
    url.split(/[?/&]+/).forEach((p) => {
      const [key, value] = p.split('=');
      if (key.startsWith(utm)) {
        tmp_utm[key] = value;
      }
    });
    return tmp_utm;
  }
}
